import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import _ from "lodash";
import { showBetterPrice } from "../../../utils/showBetterPrice";
//Styles and Icons
import LikeIcon from "../../../styles/icon/Like.svg";
import LikedIcon from "../../../styles/icon/Liked.svg";
import styles from "./Home.module.scss";
//Command Of Store
import { addFavoriteCoins } from "../../../actions/favoriteCoins";
import { useDispatch } from "react-redux";
import { Triangle } from "react-loader-spinner";
export function CoinItems() {
  let marketData = useSelector((state) => state.market.data);
  const [coinsDetails, setCoinsDetails] = useState("");
  const [activeOption, setActiveOption] = useState("");
  //For check LocalStorage
  let favUserCoins = useSelector((state) => state.favCoins);
  const dispatch = useDispatch();

  //This UseEffect For Change Show Of Coins
  useEffect(() => {
    switch (activeOption) {
      case "Rank":
        setCoinsDetails(_.take(_.sortBy(marketData, "cmcRank", "asc"), 10));
        break;
      case "Harm":
        setCoinsDetails(
          _.take(_.sortBy(marketData, "percent_change_24h", "asc"), 10)
        );
        break;
      case "Port":
        setCoinsDetails(
          _.take(
            _.sortBy(marketData, "percent_change_24h", "desc").reverse(),
            10
          )
        );
        break;
      default:
        sortByRank();
        break;
    }
  }, [activeOption, marketData]);
  //End Of UseEffect

  //Function For check and change data for show of Coins
  const sortByRank = () => {
    setActiveOption("Rank");
  };
  const sortByHarm = () => {
    setActiveOption("Harm");
  };
  const sortByPort = () => {
    setActiveOption("Port");
  };
  //Function For check and change data for show of Coins

  //For handle accordion on bottom Menu
  useEffect(() => {
    let acc = document.getElementsByClassName(
      "accordion-for-user-coin-in-home"
    );
    let panel = document.getElementsByClassName("panel-buttons");
    for (var i = 0; i < acc.length; i++) {
      acc[i].onclick = function () {
        let setClasses = !this.classList.contains("active-accord-home-menus");
        setClass(acc, "active-accord-home-menus", "remove");
        setClass(panel, "show", "remove");
        if (setClasses) {
          this.classList.toggle("active-accord-home-menus");
          this.nextElementSibling.classList.toggle("show");
        }
      };
    }
    function setClass(els, className, fnName) {
      for (let i = 0; i < els.length; i++) {
        els[i].classList[fnName](className);
      }
    }
  }, [coinsDetails]);
  return (
    <>
      <div className={styles.coin_filters}>
        <div
          className={`${styles.coin_filter} ${
            activeOption === "Port" ? styles.coin_filter_active : ""
          }`}
          onClick={sortByPort}
        >
          پرسودها
        </div>
        <div
          className={`${styles.coin_filter} ${
            activeOption === "Harm" ? styles.coin_filter_active : ""
          }`}
          onClick={sortByHarm}
        >
          پرضررها
        </div>
        <div
          className={`${styles.coin_filter} ${
            activeOption === "Rank" ? styles.coin_filter_active : ""
          }`}
          onClick={sortByRank}
        >
          رمزارزهای برتر
        </div>
      </div>
      <div className={styles.coins_header_table}>
        <div className={styles.coin_header_table}>تغییر در ۲۴ ساعت</div>
        <div className={styles.coin_header_table}>قیمت(دلاری)</div>
        <div className={styles.coin_header_table}>رمزارز</div>
      </div>
      <hr style={{ width: "100%", marginTop: "-3px" }} />
      <div className={styles.coins_info_table}>
        {_.isEmpty(coinsDetails) && (
          <div className={styles.loadingBar}>
            <Triangle color="#10D078" height={80} width={80} />
          </div>
        )}
        {coinsDetails &&
          coinsDetails.map((item, index) => (
            <div key={item.symbol + item.faName}>
              <div
                className={`accordion-for-user-coin-in-home ${styles.coin_info_table}`}
              >
                <div className={styles.coin_change_percent}>
                  <div
                    className={`${styles.coin_percent_show} ${
                      item.percent_change_24h >= 0
                        ? styles.coin_percent_show_positive
                        : styles.coin_percent_show_negative
                    }`}
                  >
                    {item.percent_change_24h}%
                  </div>
                </div>
                <div className={styles.coin_price}>
                  <div>${showBetterPrice(item.usdtPrice)}</div>
                </div>
                <div className={styles.coin_pic}>
                  <div className={styles.symbol}>{item.symbol}</div>
                  <img
                    src={`/images/assets-logo/${item.symbol}.png`}
                    alt={item.symbol}
                    width={36}
                    height={36}
                  />
                  <div>
                    <img
                      src={
                        favUserCoins.includes(item.name) ? LikedIcon : LikeIcon
                      }
                      alt=""
                      width={15}
                      height={15}
                      onClick={() => dispatch(addFavoriteCoins(item.name))}
                    />
                  </div>
                </div>
              </div>
              <div className="panel-buttons">
                <div className={styles.place_of_coin_accordion_open}>
                  <button className={styles.btn_for_acc_coins}>
                    <Link to={`/custom-convert?coin=${item?.symbol}`}>
                      سفارش گذاری
                    </Link>
                  </button>
                  <button className={styles.btn_for_acc_coins}>
                    <Link to={`/convert?coin=${item?.symbol}`}>تبدیل</Link>
                  </button>
                  <button className={styles.btn_for_acc_coins}>
                    <Link to={`/sell/${item?.symbol}`}>فروش</Link>
                  </button>
                  <button className={styles.btn_for_acc_coins}>
                    <Link to={`/buy/${item?.symbol}`}>خرید</Link>
                  </button>
                </div>
              </div>
            </div>
          ))}
      </div>
    </>
  );
}
